<script lang="ts">
	import SeoMetaTags from '$lib/components/seo/SeoMetaTags.svelte';
	import { freeTools } from '$lib/free-tools';
	import Icon from '@iconify/svelte';

	export let data;
</script>

<svelte:head>
	<SeoMetaTags
		context={data.context}
		title="Free SEO Tools: Easy-to-Use Software for Ranking Checks"
		description="Explore our collection of free SEO tools designed to help you easily check rankings, improve your site, and boost your SEO performance. Access user-friendly software and features perfect for beginners and professionals alike."
		ogTitle="Free SEO Tools: Easy-to-Use Software for Ranking Checks"
		ogDescription="Discover free, easy-to-use SEO tools that offer ranking checks, site analysis, and more. Enhance your SEO strategy with these powerful software options tailored for all skill levels."
	/>
</svelte:head>

<main class="pt-10 pb-20 px-4 max-w-screen-2xl mx-auto">
	<div class="pb-10 prose-sm sm:prose max-w-none">
		<h1 class="font-black">Free Tools</h1>
		<p class="font-medium">
			Explore our collection of free SEO tools designed to help you easily check rankings, improve
			your site, and boost your SEO performance. Access user-friendly software and features perfect
			for beginners and professionals alike.
		</p>
	</div>

	<ul class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
		{#each freeTools as { title, items }}
			<li>
				<h3 class="font-semibold mb-4">{title}</h3>
				<ul class="menu flex flex-col gap-3">
					{#each items as { href, icon, title, description }}
						<li>
							<a {href} class="grid grid-cols-[20px_auto] grid-rows-[20px_auto] gap-2 p-4">
								<Icon {icon} width="20" height="20" />
								<div class="font-semibold link col-start-2">{title}</div>
								<p class="col-span-2">{description}</p>
							</a>
						</li>
					{/each}
				</ul>
			</li>
		{/each}
	</ul>
</main>
